import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class NewProducts extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL;

    const products = [
      {
        id: "pos",
        title: "Makanza POS",
        subtitle: "Point of Sale System",
        description:
          "Sistem POS modern yang dirancang khusus untuk bisnis restoran dan cafe. Kelola pesanan, inventori, dan pembayaran dengan mudah dalam satu platform terintegrasi.",
        features: [
          "Multi-channel ordering (Dine-in, Takeaway, Delivery)",
          "Real-time inventory management",
          "Integrated payment gateway",
          "Comprehensive reporting & analytics",
          "Staff management & performance tracking",
        ],
        icon: "pe-7s-cash",
        gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        image: "/assets/img/pos-mockup.png",
        url: "https://fnb.darma.co.id/",
      },
      {
        id: "marketplace",
        title: "Makanza Marketplace",
        subtitle: "Apartment Ecosystem Platform",
        description:
          "Platform marketplace terintegrasi yang menghubungkan penghuni apartemen dengan berbagai layanan dan merchant. Solusi lengkap untuk meningkatkan pengalaman hidup di apartemen modern.",
        features: [
          "Multi-merchant marketplace",
          "QR-based ordering system",
          "Integrated delivery management",
          "Resident wallet & cashless payments",
          "Property management integration",
        ],
        icon: "pe-7s-shopbag",
        gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        image: "/assets/img/marketplace-mockup.png",
        url: "https://marketplace.darma.co.id/",
      },
    ];

    return (
      <section id="new-products" className="new-products-section pt100 pb100">
        <Container>
          <Row>
            <Col lg="8" md="10" sm="12" className="offset-lg-2 offset-md-1">
              <div className="section-title text-center mb60">
                <h2>
                  Produk <span>Terbaru</span> Kami
                </h2>
                <hr className="lines" />
                <p className="section-subtitle">
                  Solusi teknologi inovatif untuk mengakselerasi bisnis Anda di
                  era digital
                </p>
              </div>
            </Col>
          </Row>

          {products.map((product, index) => (
            <Row
              key={product.id}
              className={`product-showcase align-items-center mb80 ${index % 2 === 1 ? "flex-row-reverse" : ""}`}
            >
              <Col lg="6" md="12" className="product-content">
                <div
                  className="product-badge"
                  style={{ background: product.gradient }}
                >
                  <i className={product.icon}></i>
                </div>
                <h3 className="product-title">{product.title}</h3>
                <p className="product-subtitle">{product.subtitle}</p>
                <p className="product-description">{product.description}</p>

                <div className="product-features">
                  <h4>Fitur Utama:</h4>
                  <ul>
                    {product.features.map((feature, i) => (
                      <li key={i}>
                        <i className="fa fa-check-circle"></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="product-cta">
                  <a
                    href={product.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-modern"
                    style={{ background: product.gradient }}
                  >
                    Pelajari Lebih Lanjut
                    <i className="fa fa-arrow-right"></i>
                  </a>
                </div>
              </Col>

              <Col lg="6" md="12" className="product-visual">
                <div className="product-image-wrapper">
                  <div
                    className="floating-card"
                    style={{ background: product.gradient }}
                  >
                    <img
                      src={publicUrl + product.image}
                      alt={product.title}
                      className="img-fluid product-mockup"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentElement.innerHTML = `
                          <div class="placeholder-mockup">
                            <i class="${product.icon}"></i>
                            <p>${product.title}</p>
                          </div>
                        `;
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          ))}
        </Container>

        <style jsx="true">{`
          .new-products-section {
            background: linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%);
            position: relative;
            overflow: hidden;
          }

          .new-products-section::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 300px;
            background: radial-gradient(
              circle at 50% 0%,
              rgba(102, 126, 234, 0.1) 0%,
              transparent 70%
            );
            pointer-events: none;
          }

          .section-subtitle {
            font-size: 18px;
            color: #6c757d;
            margin-top: 15px;
            font-weight: 400;
          }

          .product-showcase {
            margin-bottom: 100px;
            position: relative;
          }

          .product-content {
            padding: 40px;
          }

          .product-badge {
            width: 70px;
            height: 70px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 25px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
            animation: float 3s ease-in-out infinite;
          }

          .product-badge i {
            font-size: 36px;
            color: white;
          }

          @keyframes float {
            0%,
            100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          .product-title {
            font-size: 42px;
            font-weight: 700;
            color: #1a1a2e;
            margin-bottom: 10px;
            line-height: 1.2;
          }

          .product-subtitle {
            font-size: 18px;
            color: #667eea;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-bottom: 20px;
          }

          .product-description {
            font-size: 16px;
            line-height: 1.8;
            color: #4a5568;
            margin-bottom: 30px;
          }

          .product-features h4 {
            font-size: 18px;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 15px;
          }

          .product-features ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .product-features li {
            display: flex;
            align-items: flex-start;
            margin-bottom: 12px;
            font-size: 15px;
            color: #4a5568;
          }

          .product-features li i {
            color: #48bb78;
            margin-right: 12px;
            margin-top: 3px;
            font-size: 18px;
          }

          .product-cta {
            margin-top: 35px;
          }

          .btn-modern {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 14px 32px;
            border-radius: 50px;
            color: white;
            font-weight: 600;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
            transition: all 0.3s ease;
            border: none;
          }

          .btn-modern:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
            color: white;
            text-decoration: none;
          }

          .btn-modern i {
            transition: transform 0.3s ease;
          }

          .btn-modern:hover i {
            transform: translateX(5px);
          }

          .product-visual {
            position: relative;
            padding: 40px;
          }

          .product-image-wrapper {
            position: relative;
            perspective: 1000px;
          }

          .floating-card {
            border-radius: 24px;
            padding: 30px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
            transition: transform 0.3s ease;
            animation: floatCard 4s ease-in-out infinite;
          }

          @keyframes floatCard {
            0%,
            100% {
              transform: translateY(0px) rotateY(0deg);
            }
            50% {
              transform: translateY(-20px) rotateY(2deg);
            }
          }

          .product-mockup {
            width: 100%;
            height: auto;
            border-radius: 12px;
            display: block;
          }

          .placeholder-mockup {
            min-height: 400px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: white;
          }

          .placeholder-mockup i {
            font-size: 120px;
            margin-bottom: 20px;
            opacity: 0.3;
          }

          .placeholder-mockup p {
            font-size: 24px;
            font-weight: 600;
            opacity: 0.5;
          }

          @media (max-width: 991px) {
            .product-showcase {
              margin-bottom: 60px;
            }

            .product-content {
              padding: 20px;
              margin-bottom: 40px;
            }

            .product-title {
              font-size: 32px;
            }

            .product-visual {
              padding: 20px;
            }
          }
        `}</style>
      </section>
    );
  }
}

export default NewProducts;
